import { Component } from '@angular/core';
import { XMLElementBaseComponent } from '../base';

@Component({
  selector: 'app-vw-image-title',
  standalone: true,
  template: `
    <div class="my-2">
      <h5 class="text-sm font-medium text-gray-800">
        @if (data.text) {
          {{ data.text }}
        }
      </h5>

      @if (data.children && data.children.length > 0) {
        <div class="mt-1 text-xs text-gray-600">({{ data.children.length }} additional items)</div>
      }
    </div>
  `,
})
export class ImageTitleComponent extends XMLElementBaseComponent {}
